import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuStatusSchema, UpdateMenuStatusRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = UpdateMenuStatusRequestSchema.strict()

const normalize = fieldNormalizer({
  enums: [{ field: 'status', options: MenuStatusSchema.options }]
})

export const MenuUpdateStatus = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
